/* stylelint-disable */
import { darken, lighten } from 'polished';
import { colors, radius } from 'css/constants';

const FlatpickrStyles = `
  .flatpickr-wrapper,
  .flatpickr-calendar {
    // This is a hack! When ConfirmDatePlugin is used, flatpickr will add 40px
    // to the height of the entire datepicker, creating a gap. Because we
    // over-ride the styles to float the confirmation button alongside the date,
    // we need to visually compensate for that here.
    &.showTimeInput {
      transform: translateY(40px);
    }

    .flatpickr-current-month .flatpickr-monthDropdown-months {
      height: auto;
    }
    
    .flatpickr-months .flatpickr-month,
    .flatpickr-weekdays,
    span.flatpickr-weekday {
      background-color: ${colors.red};
      color: #FFF;
    }

    .flatpickr-months .flatpickr-month {
      border-radius: ${radius}px ${radius}px 0 0;
    }

    .flatpickr-months {
      .flatpickr-prev-month,
      .flatpickr-next-month {
        color: #FFF;
        svg {
          width: 18px;
          height: 18px;
          stroke: #FFF;
          stroke-width: 1;
        }
        &:hover,
        &:active,
        &:focus {
          color: #FFF;
          svg {
            fill: #FFF;
          }
        }
      }
    }

    .flatpickr-months {
      .flatpickr-month,
      .flatpickr-prev-month,
      .flatpickr-next-month {
        height: 34px;
      }
    }

    span.flatpickr-day {
      &.creditActive {
        background-color: ${lighten(0.4, colors.blue)};
        &:hover,
        &:active,
        &:focus {
          background-color: #E9E9E9;
          color: #404848;
        }
      }

      &.selected,
      &.startRange,
      &.endRange,
      &.selected.inRange,
      &.startRange.inRange,
      &.endRange.inRange,
      &.selected:focus,
      &.startRange:focus,
      &.endRange:focus,
      &.selected:hover,
      &.startRange:hover,
      &.endRange:hover,
      &.selected.prevMonthDay,
      &.startRange.prevMonthDay,
      &.endRange.prevMonthDay,
      &.selected.nextMonthDay,
      &.startRange.nextMonthDay,
      &.endRange.nextMonthDay {
        color: currentColor;
        background-color: transparent;
        border-left-color: #E9E9E9;
        border-right-color: #E9E9E9;
        border-bottom-color: #E9E9E9;
        &:hover,
        &:active,
        &:focus {
          border-top-color: transparent;
        }
      }

      &.creditEndDate {
        background-color: transparent;
        .selectedPercentage {
          left: 0;
          right: auto;
          border-width: 0 4px 0 0;
          border-radius: 0 ${radius}px ${radius}px 0;
        }
        &:hover,
        &:active,
        &:focus {
          .selectedPercentage {
            border-radius: 0;
            border: none;
            background-color: #E9E9E9;
          }
        }
      }

      .selectedPercentage {
        position: absolute;
        top: -1px;
        bottom: 0;
        right: -1px;
        background-color: ${lighten(0.4, colors.blue)};
        border: 4px solid ${colors.blue};
        border-width: 0 0 0 4px;
        border-radius: ${radius}px 0 0 ${radius}px;
      }

      .selectedPercentageText {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        span {
          width: 1.75em;
          height: 1.75em;
          line-height: 1.75;
          background-color: ${colors.blue};
          color: #FFF;
          border: 1px solid #FFF;
          border-radius: 50%;
        }
      }
    }

    .flatpickr-time {
      float: left;
      display: inline-flex;
      width: 66.6%;
    }

    .flatpickr-confirm {
      float: left;
      display: inline-flex;
      width: 33.3%;
      height: 40px;
      max-height: 0;
      visibility: hidden;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #E9E9E9;
      border-bottom-right-radius: ${radius}px;
      cursor: pointer;
      svg {
        margin-left: 12px;
        fill: inherit;
        stroke: ${colors.darkGrey};
        stroke-width: 1;
      }

      &.visible {
        max-height: 40px;
        visibility: visible
      }

      &:hover,
      &:active,
      &:focus {
        background-color: ${darken(0.1, '#E9E9E9')};
      }
    }

    .flatpickr-time .flatpickr-am-pm {
      width: 28%;
    }
  }
`;

export default FlatpickrStyles;
